import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  adminCinemas,
  adminCreateCinema,
  adminUpdateCinema,
} from '../../api/endpoints';
import TopBar from '../../components/TopBar';
import { showAlert } from '../../lib/tg';

export default function CinemaForm() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { id } = useParams();
  const isEdit = !!id;
  const editId = isEdit ? Number(id) : null;

  const { data: cinemas } = useQuery({
    queryKey: ['admin-cinemas'],
    queryFn: adminCinemas,
    enabled: isEdit,
  });
  const existing = cinemas?.find((c) => c.id === editId);

  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [description, setDescription] = useState('');
  const [prefilled, setPrefilled] = useState(false);

  useEffect(() => {
    if (!isEdit || !existing || prefilled) return;
    setName(existing.name || '');
    setAddress(existing.address || '');
    setDescription(existing.description || '');
    setPrefilled(true);
  }, [isEdit, existing, prefilled]);

  const mut = useMutation({
    mutationFn: () =>
      isEdit && editId
        ? adminUpdateCinema(editId, { name, address, description })
        : adminCreateCinema({ name, address, description }),
    onSuccess: (c) => {
      qc.invalidateQueries({ queryKey: ['admin-cinemas'] });
      if (isEdit) {
        navigate('/admin/cinemas', { replace: true });
      } else {
        // New cinema → drop the admin straight into the seat editor.
        navigate(`/admin/cinemas/${c.id}/seats`, { replace: true });
      }
    },
    onError: (e: any) => {
      const detail = e?.response?.data?.detail;
      showAlert(typeof detail === 'string' ? detail : 'Ошибка сохранения');
    },
  });

  return (
    <div className="min-h-screen pb-32">
      <TopBar title={isEdit ? 'Редактировать кинотеатр' : 'Новый кинотеатр'} />
      <div className="px-4 pt-3 space-y-4">
        <div>
          <label className="label">Название</label>
          <input className="input" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div>
          <label className="label">Адрес</label>
          <input className="input" value={address} onChange={(e) => setAddress(e.target.value)} />
        </div>
        <div>
          <label className="label">Описание</label>
          <textarea className="input min-h-24" value={description} onChange={(e) => setDescription(e.target.value)} />
        </div>
        {isEdit && (
          <button
            type="button"
            className="btn-secondary w-full"
            onClick={() => navigate(`/admin/cinemas/${editId}/seats`)}
          >
            Изменить схему зала
          </button>
        )}
      </div>
      <div className="fixed bottom-0 inset-x-0 p-4 bg-bg border-t border-line">
        <button
          className="btn-primary"
          disabled={!name || mut.isPending}
          onClick={() => mut.mutate()}
        >
          {isEdit ? 'Сохранить' : 'Сохранить и настроить схему'}
        </button>
      </div>
    </div>
  );
}
